export default "/images/6.png?167cd7094e6549bcdcf01a5dc01afc0a";